import { render, staticRenderFns } from "./PowerBiExport.vue?vue&type=template&id=06a9d27f&"
import script from "./PowerBiExport.vue?vue&type=script&lang=ts&"
export * from "./PowerBiExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports